import Image from 'next/image'
import moment from 'moment'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import calculateDiscount from '../../Discounts/discount'

const BookingDetails = ({
  price,
  extraCharge,
  getDetails,
  currency,
  vat,
  originalPrice,
  optionType,
  group,
  groupAmt,
  groupOriginalAmt,
  totalPay,
  setTotalPay
}) => {
  const router = useRouter()
  const {
    _id,
    city,
    checkIn,
    checkOut,
    adult,
    child,
    senior,
    packageName,
    choiceName,
    image,
    date,
    time,
    adultAmt,
    childAmt,
    seniorAmt
  } = router.query
  // const [totalPay, setTotalPay] = useState(price)
  const [discountAmount, setDiscountAmount] = useState(0)
  const [shortDescription, setShortDescription] = useState('')

  useEffect(() => {
    const storedDescription = localStorage.getItem('shortDescription') || ''
    setShortDescription(storedDescription)
  }, [])

  // useEffect(() => {
  //   if (getDetails?.discountAmount) {
  //     setTotalPay(getDetails?.discountAmount);
  //     setDiscountAmount(getDetails?.discountAmount);
  //   } else if (price && !getDetails?.discountAmount) {
  //     setTotalPay(price);
  //   }
  // }, [getDetails, price]);

  useEffect(() => {
    const { discountAmount, totalPay } = calculateDiscount(price, getDetails)
    setDiscountAmount(discountAmount)
    setTotalPay(totalPay)
  }, [getDetails, price])

  const isDiscountAvailable = originalPrice > price

  return (
    <div className='px-20 py-20 border-light rounded-4'>
      <div
        className='row x-gap-15 y-gap-20'
        style={{ cursor: 'pointer' }}
        onClick={() => router.back()}
      >
        <div className='col-4'>
          {/* <Image
            width={140}
            height={140}
            src="/img/backgrounds/1.png"
            alt="image"
            className="size-140 rounded-4 object-cover"
          /> */}
          <img
            src={`${process.env.IMAGE_BASE_URL}/${image}`}
            alt='image'
            width={140}
            height={140}
            className='size-140 rounded-4 object-cover'
          />
        </div>
        {/* End .col */}
        <div className='col-8 relative'>
          <h5 className='shortDescription1'>{packageName}</h5>
          {shortDescription && shortDescription !== '' && (
            <div className='shortDescription1 text-light-1'>
              {shortDescription}
            </div>
          )}

          <div
            className='absolute'
            style={{
              bottom: '10px'
            }}
          >
            {moment(date).format('ddd, MMM D')}
          </div>
        </div>
        {/* End .col */}
      </div>
      {/* End .row */}

      <div className='border-top-light mt-15 mb-10' />
      <div className='row justify-between'>
        <div>
          <h5 style={{ paddingLeft: '0px' }}>{`Admission to ${choiceName}`}</h5>
        </div>
      </div>
      <div className='row y-gap-20 justify-between'>
        <div>
          <table className='w-100'>
            {optionType == 2 ? (
              <>
                {adult && (
                  <tr className='js-spbt mt-10'>
                    <td colSpan='1'>
                      <div>
                        <div className='f-size-14'>
                          {adult} 𝗑 Adult (age 12+)
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className='f-size-14'>
                        {isDiscountAvailable && (
                          <span className='text-decoration-line-through mx-2 text-12'>
                            {currency?.toUpperCase()} {originalPrice}
                          </span>
                        )}
                        {currency?.toUpperCase()} {adult * adultAmt}
                      </div>
                    </td>
                  </tr>
                )}
                {child > 0 && (
                  <tr className='js-spbt'>
                    <td colSpan='1'>
                      <div>
                        <div className='f-size-14'>
                          {child} 𝗑 Child (age 4–11)
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className='f-size-14'>
                        {isDiscountAvailable && (
                          <span className='text-decoration-line-through mx-2 text-12'>
                            {currency?.toUpperCase()} {originalPrice}
                          </span>
                        )}
                        {currency?.toUpperCase()} {child * childAmt}
                      </div>
                    </td>
                  </tr>
                )}
                {senior > 0 && (
                  <tr className='js-spbt'>
                    <td colSpan='1'>
                      <div>
                        <div className='f-size-14'>
                          {senior} 𝗑 Senior (age 55–99)
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className='f-size-14'>
                        {isDiscountAvailable && (
                          <span className='text-decoration-line-through mx-2 text-12'>
                            {currency?.toUpperCase()} {originalPrice}
                          </span>
                        )}
                        {currency?.toUpperCase()} {senior * seniorAmt}
                      </div>
                    </td>
                  </tr>
                )}
              </>
            ) : (
              <>
                {group > 0 && (
                  <tr className='js-spbt'>
                    <td colSpan='1'>
                      <div>
                        <div className='f-size-14'>{group} 𝗑 Group </div>
                      </div>
                    </td>
                    <td>
                      <div className='f-size-14'>
                        {isDiscountAvailable && (
                          <span className='text-decoration-line-through mx-2 text-12'>
                            {currency?.toUpperCase()} {originalPrice}
                          </span>
                        )}
                        {currency?.toUpperCase()} {group * groupAmt}
                      </div>
                    </td>
                  </tr>
                )}
              </>
            )}
            <tr className='js-spbt align-end'>
              <td colSpan='1'>
                <div>
                  <div className='f-size-14 fw-600'>Total</div>
                </div>
              </td>
              <td>
                <div className='f-size-14 fw-600'>
                  {optionType == 2 ? (
                    <>
                      {currency?.toUpperCase()}{' '}
                      {adult * adultAmt + child * childAmt + senior * seniorAmt}
                    </>
                  ) : (
                    <>
                      {currency?.toUpperCase()} {group * groupAmt}
                    </>
                  )}
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>

      {/* SPLIT AMOUNT */}
      <div className='border-top-light mt-10 mb-10' />
      <div className='row justify-between'>
        <div className='col-auto'>
          {originalPrice !== 0 && originalPrice !== price && (
            <div className='text-15'>Actual Price</div>
          )}
          {isDiscountAvailable && <div className='text-15'>Extra Discount</div>}
          {isDiscountAvailable ? (
            <div className='text-15'>Discounted Price</div>
          ) : (
            <div className='text-15'>Actual Price</div>
          )}
          {discountAmount !== 0 && (
            <div className='text-15'>Promotion Discount</div>
          )}
          {discountAmount !== 0 && <div className='text-15'>Sub Total</div>}
          {extraCharge !== '0' && extraCharge !== 0 ? (
            <div className='text-15'>Extra Price</div>
          ) : null}
          {/* {Number(vat) !== 0 && <div className="text-15">VAT(5%)</div>} */}
          {/* <div className="text-15">To Pay</div> */}
        </div>

        <div className='col-auto text-right md:text-left'>
          {originalPrice !== 0 && originalPrice !== price && (
            <div className='fw-500'>
              {currency?.toUpperCase()} {originalPrice}
            </div> // 1000
          )}
          {isDiscountAvailable && (
            <div className='fw-500 text-success'>
              - {currency?.toUpperCase()} {originalPrice - price}
            </div> // 1000
          )}
          {price !== 0 && (
            <div className='fw-500'>
              {currency?.toUpperCase()} {price}
            </div> // 600
          )}
          {discountAmount !== 0 && (
            <div className='fw-500 text-success'>
              -{' '}
              {discountAmount !== '-'
                ? `${currency?.toUpperCase()} ${discountAmount}`
                : ''}
            </div> // 400
          )}
          {discountAmount !== 0 && (
            <div className='fw-500'>
              {discountAmount !== '-'
                ? `${currency?.toUpperCase()} ${Number(totalPay)}`
                : ''}
            </div> // 200   // To pay = 210 + 10. 5 = 220.5
          )}
          {extraCharge !== '0' && extraCharge !== 0 ? (
            <div className='fw-500'>
              {currency?.toUpperCase()} {extraCharge}
            </div> // 10
          ) : null}
        </div>
      </div>
      <div className='border-top-light mt-10 mb-10' />
      <div className='row justify-between'>
        <div className='col-auto'>
          {Number(vat) !== 0 && <div className='text-15'>VAT(5%)</div>}
          <div className='text-15'>To Pay</div>
        </div>

        <div className='col-auto text-right md:text-left'>
          {Number(vat) !== 0 && (
            <div className='fw-500'>
              {currency?.toUpperCase()}{' '}
              {vat === 0
                ? '-'
                : `${((totalPay + Number(extraCharge)) * vat) / 100}`}
            </div> // (200 + 10) * 5 / 100 = 10.5
          )}
          <div className='fw-600'>
            {currency?.toUpperCase()}{' '}
            {(totalPay +
              Number(extraCharge) +
              ((totalPay + Number(extraCharge)) * vat) / 100).toFixed(2)}
          </div>
        </div>
      </div>
    </div>

    // End px-30
  )
}

export default BookingDetails
